import { v4 as uuid } from "uuid";
import { formatDate } from "../utils/authUtils";
/**
 * User Database can be added here.
 * You can add default users of your wish with different attributes
 * */

export const users = [
  {
    _id: uuid(),
    firstName: "Tessa",
    lastName: "Thompson",
    username: "tessathom",
    bio:"Full Stack Developer", 
    website: "https://google.com.",
    password: "tessathom123",
    avatar: "https://res.cloudinary.com/dhqxln7zi/image/upload/v1652867276/istockphoto-1168369629-612x612_wko9dt.jpg",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    followers: [{
      _id: uuid(), firstName: "Abhishek",
      lastName: "Gautam",avatar: "https://t3.ftcdn.net/jpg/01/36/49/90/360_F_136499077_xp7bSQB4Dx13ktQp0OYJ5ricWXhiFtD2.jpg", username: "abhishekg",
    }], 
    following: []
  },
  {
    _id: uuid(),
    firstName: "Pritam",
    lastName: "Kumar",
    username: "pritamkr",
    bio:"I Learn, Build, and Share with you.", 
    website: "https://pritam-kumar.netlify.app/",
    avatar: "https://avatars.githubusercontent.com/u/84632214?v=4",
    password: "pritamkr123",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    followers: [],
    following: [],
  },
  {
    _id: uuid(),
    firstName: "Abhishek",
    lastName: "Gautam",
    username: "abhishekg",
    bio:"MERN Stack Developer.", 
    website: "https://abhishekgautam.netlify.app/",
    avatar: "https://avatars.githubusercontent.com/u/46835940?v=4",
    password: "abhishekG123",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    followers: [],
    following: [{
      _id: uuid(), firstName: "Pritam",
      lastName: "Kumar",avatar: "https://t3.ftcdn.net/jpg/01/36/49/90/360_F_136499077_xp7bSQB4Dx13ktQp0OYJ5ricWXhiFtD2.jpg", username: "pritamkr123",
    }],
  },
  {
    _id: uuid(),
    firstName: "Srishti",
    lastName: "Maurya",
    username: "srishtim",
    bio:"Full Stack Developer", 
    website: "https://srishti-maurya.netlify.app/",
    avatar: "https://avatars.githubusercontent.com/u/39724354?v=4",
    password: "srishtim123",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    followers: [],
    following: [],
  },
  {
    _id: uuid(),
    firstName: "Shruti",
    lastName: "Raj",
    username: "shrutir",
    bio:"Full Stack Developer", 
    website: "https://shruti-raj-portfolio.netlify.app/",
    avatar: "https://avatars.githubusercontent.com/u/69633187?v=4",
    password: "shrutir123",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    followers: [],
    following: [],
  },
  {
    _id: uuid(),
    firstName: "Flora",
    lastName: "",
    username: "florab",
    bio:"Front end Developer", 
    website: "https://kitni-pyaari-hai.netlify.app/",
    avatar: "https://kitni-pyaari-hai.netlify.app/happy-smiling.gif",
    password: "flora123",
    createdAt: formatDate(),
    updatedAt: formatDate(),
    followers: [],
    following: [],
  },
];
